import { ConnectionsClient } from "../Models/Api/strongbox.client";
import { ConnectionRequestDescriptor, ConnectionRequestParameters } from "../Models/Api/strongbox.models";
import { StrongboxConnectionDescriptor } from "../Utils/ConnectStrongbox";

export class OrganizationsService {

    public async StartGetFinancialsConnectionDescriptor(connectionInfo: StrongboxConnectionDescriptor): Promise<ConnectionRequestDescriptor> {
        const connections = new ConnectionsClient(connectionInfo.delegatedAccessToken, connectionInfo.strongboxUri);

        let parameters: { [key: string]: string; } | undefined = undefined;

        if (connectionInfo.sourceFlow === 'borrower') {
            parameters = {
                mode: 'borrower'
            }
        }

        // RequestNameSource is the datasource the connector is keyed on (defaults to nameId). RequestNamePackage,
        // when present, discriminates the ERP for a shared connector source and is passed as the 'erp' parameter.
        if (connectionInfo.accountingPackage.requestNamePackage) {
            parameters = {
                ...(parameters || {}),
                erp: connectionInfo.accountingPackage.requestNamePackage,
            };
        }

        const requestParameters = new ConnectionRequestParameters({
            datasourceNameId: connectionInfo.accountingPackage.requestNameSource || connectionInfo.accountingPackage.nameId,
            parameters
        });
        const response = await connections.createRequest(
            connectionInfo.orgId,
            requestParameters,
        );

        if (!this.goodResponse(response.status)) {
            throw new Error("Bad Response");
        }

        return response.result;
    }

    goodResponse(status: number): boolean {
        return status === 200 || status === 201 || status === 204;
    }
}